import React from "react";
import Pulsar from "hero/components/Pulsar";
import { enforceDoubles } from "core/utils/general";
var Countdown = function (_a) {
    var duration = _a.duration;
    var hours = enforceDoubles(Math.floor(duration / (60 * 60 * 1000)));
    var minutesRemaining = duration % (60 * 60 * 1000);
    var minutes = enforceDoubles(Math.floor(minutesRemaining / (60 * 1000)));
    var secondsRemaining = minutesRemaining % (60 * 1000);
    var seconds = enforceDoubles(Math.floor(secondsRemaining / 1000));
    var time = "".concat(hours, ":").concat(minutes, ":").concat(seconds);
    return React.createElement(Pulsar, null, time);
};
export default Countdown;
